var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.productTasksFeature.show
    ? _c("div", { staticClass: "mb-6" }, [
        _vm.productReleases.length > 0
          ? _c("div", { staticClass: "card-item" }, [
              _c("span", { staticClass: "is-flex is-align-items-center" }, [
                _vm._m(0),
                _c("span", [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "has-text-grey has-text-weight-medium is-size-6 mt-0",
                    },
                    [_vm._v(_vm._s(_vm.$t("teamReleasesMessage")))]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "box p-2 my-1",
                  attrs: { "data-cy": "doings-product" },
                },
                _vm._l(_vm.productReleases, function (message, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "message-item",
                        {
                          "last-message":
                            index === _vm.productReleases.length - 1,
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-item-inner p-3 my-1" },
                        [
                          _c("header", [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-justify-content-space-between is-align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-flex-direction-column",
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-medium is-size-6",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.value)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center is-flex-wrap-wrap mt-2",
                                              },
                                              [
                                                message.releaseLink
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: message.releaseLink,
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-tag",
                                                          {
                                                            attrs: {
                                                              rounded: "",
                                                              icon: "link",
                                                              type: "is-light mr-2",
                                                            },
                                                          },
                                                          [_vm._v("Ver")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "b-tag",
                                                  {
                                                    attrs: {
                                                      rounded: "",
                                                      type: "is-light mr-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        message.productSection
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "is-size-7 has-text-grey-light",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.country)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "is-size-7 has-text-grey-light ml-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateFormat(
                                                          message.state
                                                            .releaseDate
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-align-items-center",
                                                  },
                                                  [
                                                    _c("b-rate", {
                                                      staticClass: "pt-2 ml-4",
                                                      attrs: {
                                                        "icon-pack": "fas",
                                                        size: "is-small",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleRatingChange(
                                                            message._id,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: message.rating,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            message,
                                                            "rating",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "message.rating",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "is-size-7 has-text-grey-light ml-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            message.votesNumber
                                                          ) + " votos"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "toggleButton is-rounded ml-2",
                                          attrs: {
                                            size: "is-small",
                                            "aria-expanded":
                                              message.notificationCollapse,
                                            "aria-controls": "notification",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleNotificationCollapse(
                                                index,
                                                _vm.productReleases
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas",
                                            class: {
                                              "fa-angle-down":
                                                !message.notificationCollapse,
                                              "fa-angle-up":
                                                message.notificationCollapse,
                                            },
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "b-collapse",
                            {
                              staticClass: "message-body is-size-7",
                              attrs: {
                                "aria-id": "notification",
                                animation: "slide",
                              },
                              model: {
                                value: message.notificationCollapse,
                                callback: function ($$v) {
                                  _vm.$set(message, "notificationCollapse", $$v)
                                },
                                expression: "message.notificationCollapse",
                              },
                            },
                            [
                              _c("div", { staticClass: "content mt-3 p-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "is-flex" },
                                  [
                                    message.sprintNumber
                                      ? _c(
                                          "b-tag",
                                          {
                                            staticClass: "mr-2 team-icon",
                                            attrs: {
                                              rounded: "",
                                              type: "is-light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Sprint #" +
                                                _vm._s(message.sprintNumber)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "team-icon mb-3",
                                        attrs: {
                                          icon: "people-group",
                                          rounded: "",
                                          type: "is-light",
                                        },
                                      },
                                      [_vm._v(_vm._s(message.state.team))]
                                    ),
                                  ],
                                  1
                                ),
                                _c("p", {
                                  staticClass: "mb-0",
                                  domProps: {
                                    innerHTML: _vm._s(message.description),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm.productDoingsMessages.length > 0
          ? _c("div", { staticClass: "mt-3 card-item" }, [
              _c("span", { staticClass: "is-flex is-align-items-center" }, [
                _vm._m(1),
                _c("span", [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "has-text-grey has-text-weight-medium is-size-6 mt-0",
                    },
                    [_vm._v(_vm._s(_vm.$t("teamWorkingMessage")))]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "box p-2 my-1",
                  attrs: { "data-cy": "doings-product" },
                },
                _vm._l(_vm.productDoingsMessages, function (message, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "message-item",
                        {
                          "last-message":
                            index === _vm.productDoingsMessages.length - 1,
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-item-inner p-3 my-1" },
                        [
                          _c("header", [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-justify-content-space-between is-align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "is-flex is-flex-direction-column",
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-medium is-size-6",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.value)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center mt-2",
                                              },
                                              [
                                                message.releaseLink
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: message.releaseLink,
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-tag",
                                                          {
                                                            attrs: {
                                                              rounded: "",
                                                              icon: "link",
                                                              type: "is-light mr-2",
                                                            },
                                                          },
                                                          [_vm._v("Ver")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "b-tag",
                                                  {
                                                    attrs: {
                                                      rounded: "",
                                                      type: "is-light mr-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        message.productSection
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "is-size-7 has-text-grey-light",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.country)
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "toggleButton is-rounded ml-2",
                                          attrs: {
                                            size: "is-small",
                                            "aria-expanded":
                                              message.notificationCollapse,
                                            "aria-controls": "notification",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleNotificationCollapse(
                                                index,
                                                _vm.productDoingsMessages
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas",
                                            class: {
                                              "fa-angle-down":
                                                !message.notificationCollapse,
                                              "fa-angle-up":
                                                message.notificationCollapse,
                                            },
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "b-collapse",
                            {
                              staticClass: "message-body is-size-7",
                              attrs: {
                                "aria-id": "notification",
                                animation: "slide",
                              },
                              model: {
                                value: message.notificationCollapse,
                                callback: function ($$v) {
                                  _vm.$set(message, "notificationCollapse", $$v)
                                },
                                expression: "message.notificationCollapse",
                              },
                            },
                            [
                              _c("div", { staticClass: "content mt-3 p-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "is-flex" },
                                  [
                                    message.sprintNumber
                                      ? _c(
                                          "b-tag",
                                          {
                                            staticClass: "mr-2 team-icon",
                                            attrs: {
                                              rounded: "",
                                              type: "is-light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Sprint #" +
                                                _vm._s(message.sprintNumber)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "team-icon mb-3",
                                        attrs: {
                                          icon: "people-group",
                                          rounded: "",
                                          type: "is-light",
                                        },
                                      },
                                      [_vm._v(_vm._s(message.state.team))]
                                    ),
                                  ],
                                  1
                                ),
                                _c("p", {
                                  staticClass: "mb-0",
                                  domProps: {
                                    innerHTML: _vm._s(message.description),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "icon-item is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("i", {
          staticClass: "fa-solid fa-truck-fast has-text-primary is-size-5",
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "icon-item is-flex is-align-items-center is-justify-content-center",
      },
      [_c("i", { staticClass: "fa-solid fa-code has-text-primary is-size-5" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }